export default __webpack_public_path__ + "static/media/download-group-images.f5b8093d.svg";